import { Button, Checkbox, Form, Radio } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BlankPdfIcon from "../../../assets/icons/BlankPdfIcon";
import pdfIcon from "../../../assets/images/Rectangle 4022.png";
import { APP_NAME, IMAGE_URL } from "../../../constants/constants";
import useModal from "../../../hooks/useModal";
import AdminLayout from "../../../layouts/AdminLayout";
import { formatDate, formatHour } from "../../../lib/time";
import {
  singPublicationAsync,
  updatePublicationAsync,
} from "../../../store/features/contentManagment/contentManagmentApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import CustomSection from "../../ui/CustomSection";
import IconicTitle from "../../ui/IconicTitle";
import { toast } from "../../../lib/toast";

export default function ContentView() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { open, handleOpen, toggle } = useModal();
  const { singleContentData } = useAppSelector((state) => state.publication);

  const [checkAll, setCheckAll] = useState(false);

  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const handleChange = (e: any) => {
    setSelectedValue(e.target.value);
  };

  const handleCheckAll = (e: any) => {
    const checked = e.target.checked;
    setCheckAll(checked);
  };

  const handleSubmit = () => {
    // console.log({ checkAll });
    console.log({ selectedValue });

    if (checkAll && selectedValue) {
      dispatch(
        updatePublicationAsync({
          data: {
            _id: id || "",
            publicationTitle: singleContentData?.publicationTitle || "",
            categoryId: singleContentData?.categoryId._id || "",
            publicationThumbnail: singleContentData?.publicationThumbnail || "",
            publicationFiles: singleContentData?.publicationFiles || [],
            publicationContent: singleContentData?.publicationContent || "",
            publicationStatus: selectedValue,
          },
          others: {
            reRender: () => console.log("Re-render triggered"),
            id: id,
          },
        })
      );
    } else {
      toast("error", "Select an option and confirm");
    }
  };

  useEffect(() => {
    dispatch(
      singPublicationAsync({
        params: {
          reRender(val) {},
          id: id + "",
        },
      })
    );
  }, [dispatch, id]);

  // useEffect(() => {
  //   if (singleContentData?.publicationStatus) {
  //     setSelectedStatus(singleContentData.publicationStatus);
  //   }
  // }, [singleContentData?.publicationStatus]);

  return (
    <AdminLayout title="Post View" backLink="/admin/content-manage/content">
      <Form
        className="custom-form space-y-[14px]"
        layout="vertical"
        size="large"
      >
        <CustomSection>
          <div className="h-8 px-1.5 py-1 bg-[#ffc107] justify-center items-center inline-flex">
            <div className="text-center text-black text-sm font-semibold tracking-[0.2px]">
              {singleContentData?.publicationStatus || "N/A"}
            </div>
          </div>

          <div className="text-[#212529] text-5xl font-semibold leading-[60px]">
            {singleContentData?.publicationTitle || "N/A"}
          </div>

          <div className="py-6 justify-start items-center inline-flex">
            <div className="justify-start items-center gap-3 flex">
              <div className="flex-col justify-start items-end inline-flex">
                <img
                  className="w-14 h-14 rounded-full"
                  src={
                    singleContentData?.publicationAuthor?.profilePicture
                      ? singleContentData?.publicationAuthor?.profilePicture
                      : undefined
                  }
                  alt={APP_NAME}
                />
              </div>

              <div className="flex-col justify-center items-start gap-1 inline-flex">
                <div className="justify-start items-start gap-1.5 inline-flex">
                  <div className="text-[#495057] text-base font-semibold font-['Encode Sans Condensed'] leading-normal">
                    {singleContentData?.publicationAuthor?.fullName || "N/A"}
                  </div>
                  <div className="text-[#adb5bd] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
                    |
                  </div>
                  <div className="text-[#495057] text-sm font-semibold font-['Encode Sans Condensed'] leading-snug">
                    {singleContentData?.publicationAuthor?.designation || "N/A"}
                  </div>
                </div>
                <div className="justify-start items-start gap-1.5 inline-flex">
                  <div className="text-[#6c757d] text-sm font-medium font-['Encode Sans Condensed'] leading-snug">
                    Last updated: {formatDate(singleContentData?.updatedAt)}{" "}
                    {formatHour(singleContentData?.updatedAt)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6 border border-[#e9eff6] border-solid" />

          <div className="flex-col justify-start items-start gap-6 inline-flex">
            <img
              className="self-stretch h-[434.88px]"
              loading="lazy"
              src={
                singleContentData?.publicationThumbnail
                  ? IMAGE_URL + singleContentData?.publicationThumbnail
                  : undefined
              }
              alt={APP_NAME}
            />
            {/* <div className="text-[#343a40] text-base  leading-7">
              {singleContentData?.publicationContent}
            </div> */}
            <div
              className="text-[#343a40] text-base leading-7"
              dangerouslySetInnerHTML={{
                __html: singleContentData?.publicationContent || "",
              }}
            />
          </div>
        </CustomSection>

        <CustomSection>
          <IconicTitle
            icon={<BlankPdfIcon />}
            className="text-primary"
            title="PDF File Attachment"
          />

          <div className="grid sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-9 items-center gap-6 mt-6">
            {singleContentData?.publicationFiles?.map((val, idx) => (
              <a
                key={idx}
                className="w-[105px] flex-col justify-start items-start gap-2.5 inline-flex cursor-pointer"
                href={val}
                download
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="self-stretch h-[124.50px] rounded-[3px] border border-[#e9eff6]"
                  src={pdfIcon}
                  alt={APP_NAME}
                />
                <div className="text-body text-sm font-medium leading-tight whitespace-nowrap">
                  Attachment title
                </div>
              </a>
            ))}
          </div>
        </CustomSection>

        {/* <CustomSection>
          <div className="flex items-center gap-x-2.5 mb-4">
            <Radio.Group
              className="custom-radio"
              onChange={handleChange}
              value={selectedValue}
              size="large"
            >
              {statusList?.map((el, idx) => (
                <Radio
                  className="text-body text-base font-medium leading-7 mr-3.5"
                  value={el.value}
                  key={idx}
                  disabled={!!id}
                >
                  {el.label}
                </Radio>
              ))}
            </Radio.Group>
          </div>

          <div className="border border-solid border-[#d7dee8] mt-1 mb-4 w-full" />
          <div className="flex justify-between items-center">
            <Checkbox
              checked={checkAll}
              onChange={handleCheckAll}
              className=""
              disabled={!!id}
            >
              <span className="text-body text-sm font-medium leading-normal">
                Yes! I confirmed and Publish this event
              </span>
            </Checkbox>
            <div className="flex gap-x-[12px]">
              <Button
                className="cancel-btn"
                type="text"
                size="large"
                // onClick={() =>
                //   handleOpen({
                //     type: "EDIT",
                //   })
                // }
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>

              <Button
                className="primary_btn"
                type="primary"
                size="large"
                onClick={handleSubmit}
                disabled={!!id}
              >
                Submit
              </Button>
            </div>
          </div>
        </CustomSection> */}
      </Form>
    </AdminLayout>
  );
}

// const statusList = ["Save as Draft", "Archive", "Bank to Author", "Publish"];
const statusList = [
  {
    label: "Save as Draft",
    value: "Draft",
  },
  {
    label: "Archive",
    value: "Archived",
  },
  {
    label: "Bank to Author",
    value: "Back_To_Author",
  },
  {
    label: "Publish",
    value: "Published",
  },
];
